<script setup lang="ts">
import { Datapack, PackMcmeta } from 'mc-datapack-loader';
import { TextComponent } from '../util/TextComponent';
import MinecraftText from './MinecraftText.vue';
import { useSettingsStore } from '../stores/useSettingsStore';
import { versionMetadata } from '../util';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

    const i18n = useI18n()

    const props = defineProps({
        datapack: Object,
        removable: Boolean
    })

    const settings = useSettingsStore()


    const datapack = (props.datapack as Datapack)!
    const image = await datapack.getImage()
    const mcMeta = await datapack.getMcmeta()
    const supported = computed(() => mcMeta !== undefined ? PackMcmeta.MatchFormatRange(mcMeta.formats, versionMetadata[settings.mc_version].datapackFormat) : false)
    const desciption = TextComponent.parse(mcMeta?.description ?? "")

</script>

<template>
    <div class="datapack" :class="{ unsupported: !supported}">
        <img class="image" :src="image" alt="pack.png" />
        <div class="description">
            <MinecraftText :component="desciption" />
        </div>
        <font-awesome-icon v-if="removable" icon="fa-xmark" class="close_button" tabindex="0" :title="i18n.t('datapack_list.remove_datapack.title')" @click="$emit('close')" @keypress.enter="$emit('close')" />
    </div>
</template>

<style scoped>
    .datapack {
        width: 100%;
        height: 4rem;
        box-sizing: border-box;
        background-color: #ffffff;
        color: #334155;
        border: 1px solid #e2e8f0;
        border-radius: 8px;
        display: flex;
        align-items: center;
        position: relative;
        padding-inline-end: 0.3rem;
        gap: 0.3rem;
    }

    .datapack.unsupported {
        background-color: #fff5f5;
        border-color: #fecaca;
    }

    .image {
        width: 4rem;
        height: 4rem;
        border-radius: 7px 0 0 7px;
        user-select: none;
    }

    .image:dir(rtl) {
        border-radius: 0 0.5rem 0.5rem 0;
    }

    .description {
        flex-grow: 1;
        text-align: center;
        overflow: hidden;
        max-height: 100%;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        font-family: sans-serif;
        font-size: 16px;
        line-height: 1.2rem;
    }

    .close_button {
        position: absolute;
        right: 1rem;
        background-color: #f1f5f9;
        color: #64748b;
        padding: 0.25rem;
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 6px;
        opacity: 0;
        transition: 0.1s;
        cursor: pointer;
    }

    .datapack:hover .close_button, .close_button:focus {
        opacity: 1;
    }

    .close_button:hover, .close_button:focus {
        background-color: #fee2e2;
        color: #b91c1c;
    }
</style>
